import { memo } from 'react';

import { Dialog, Modal, ModalOverlay, ModalOverlayProps } from '@/components/core';
import { NewTrigger, OnTriggerOptionSelected } from '@/components/flow';

export type NewTriggerModalProps = ModalOverlayProps & {
  onTriggerOptionSelected?: OnTriggerOptionSelected;
  isAddingTrigger?: boolean;
  errors?: Error[];
};

const INewTriggerModal = ({ onTriggerOptionSelected, isAddingTrigger, errors, ...rest }: NewTriggerModalProps) => {
  return (
    <ModalOverlay {...rest}>
      <Modal>
        <Dialog aria-label="NewTriggerModal" className="outline-none">
          <NewTrigger
            onTriggerOptionSelected={onTriggerOptionSelected}
            isAddingTrigger={isAddingTrigger}
            errors={errors}
            className="h-[30rem] w-[30rem] p-1"
          />
        </Dialog>
      </Modal>
    </ModalOverlay>
  );
};

export const NewTriggerModal = memo(INewTriggerModal) as typeof INewTriggerModal;
